export default __webpack_public_path__ + "static/foresthill-c6c123b3d3c7d907f44699de8223c338.png";